import axios from 'axios';

export async function pollSubscriptionStatus(maxAttempts = 10, intervalMs = 3000) {
  let attempts = 0;

  const poll = async () => {
    try {
      const response = await axios.get('/api/billing/subscription/status/', {
        withCredentials: true,
      });

      console.log(`[Attempt ${attempts + 1}/${maxAttempts}] Subscription status:`, response.data);

      attempts++;

      if (response.data.status === 'pending' && attempts < maxAttempts) {
        // Continue polling
        await new Promise(resolve => setTimeout(resolve, intervalMs));
        return poll();
      } else if (response.data.status === 'pending' && attempts >= maxAttempts) {
        console.warn('Max polling attempts reached. Status still pending.');
        return {
          status: 'timeout',
          message: 'Оплата обробляється, перевірте пізніше',
        };
      } else {
        // Status changed from pending (e.g., "active")
        console.log('Subscription status changed:', response.data.status);
        return response.data;
      }
    } catch (error) {
      console.error('Error checking subscription status:', error);
      attempts++;

      if (attempts < maxAttempts) {
        // Retry on error
        await new Promise(resolve => setTimeout(resolve, intervalMs));
        return poll();
      } else {
        return {
          status: 'error',
          message: 'Помилка при перевірці статусу підписки',
        };
      }
    }
  };

  return poll();
}


